import React, { memo, useCallback } from 'react'
import { Badge, Tooltip } from 'antd'
import { ThunderboltFilled } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import useNavigation from '@/utils/hooks/useNavigation'
import styles from './style.module.scss'

export const SYNC_HISTORY_PATH = '/cashier/settings/sync-history'

/**
 * Indikator Mode Zero-Loading di sidebar kasir: ikon petir + jumlah transaksi yang perlu
 * tindakan (gagal / terblokir, merah) atau titik oranye bila masih ada yang dikirim. Klik →
 * Pusat Sinkronisasi.
 */
const ZeroLoadingStatusBadge = ({ counts }) => {
  const { formatMessage } = useIntl()
  const { onNavigate } = useNavigation()
  const needsAction = counts.failed + (counts.blocked ?? 0)
  const waiting = counts.pending + counts.sent

  let tone = ''
  let statusText = formatMessage({ id: 'pos.sync_history.status_synced' })
  if (needsAction > 0) {
    tone = styles.danger
    statusText = formatMessage({ id: 'pos.sync_center.hero.action' }, { count: needsAction })
  } else if (waiting > 0) {
    tone = styles.warning
    statusText = formatMessage({ id: 'pos.sync_history.status_waiting' }, { count: waiting })
  }

  const handleOpen = useCallback(() => onNavigate(SYNC_HISTORY_PATH), [onNavigate])

  return (
    <div className={styles.sidebarBadgeWrap}>
      <Tooltip
        placement="right"
        title={
          <div>
            <strong>{formatMessage({ id: 'pos.zero_loading.badge' })}</strong>
            <div>{statusText}</div>
          </div>
        }
      >
        <Badge
          count={needsAction}
          dot={needsAction === 0 && waiting > 0}
          size="small"
          offset={[-4, 4]}
        >
          <span
            className={`${styles.sidebarBadge} ${tone}`}
            role="button"
            tabIndex={0}
            aria-label={`${formatMessage({ id: 'pos.zero_loading.badge' })}: ${statusText}`}
            onClick={handleOpen}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                handleOpen()
              }
            }}
          >
            <ThunderboltFilled />
          </span>
        </Badge>
      </Tooltip>
    </div>
  )
}

export default memo(ZeroLoadingStatusBadge)
